import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import { ROUTES } from 'config/routes';
import LoadingSkeleton from 'components/feedback/LoadingSkeleton';
import {
  CheckoutPage,
  OrderConfirmationPage,
} from 'pages';

const Lazy = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<LoadingSkeleton rows={3} />}>{children}</Suspense>
);

export const checkoutRoutes = (
  <>
    <Route path={ROUTES.CHECKOUT} element={<Lazy><CheckoutPage /></Lazy>} />
    <Route path={ROUTES.ORDER_CONFIRMATION} element={<Lazy><OrderConfirmationPage /></Lazy>} />
  </>
);
